/**
 * Склонение существительных по числу (русский язык).
 * pluralize(1, 'филиал', 'филиала', 'филиалов') → '1 филиал'
 * pluralize(3, 'филиал', 'филиала', 'филиалов') → '3 филиала'
 * pluralize(21, 'филиал', 'филиала', 'филиалов') → '21 филиал'
 */
export function pluralize(
  count: number,
  one: string,
  few: string,
  many: string,
): string {
  const abs = Math.abs(count);
  const mod10 = abs % 10;
  const mod100 = abs % 100;

  if (mod100 >= 11 && mod100 <= 19) {
    return `${count} ${many}`;
  }
  if (mod10 === 1) {
    return `${count} ${one}`;
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return `${count} ${few}`;
  }
  return `${count} ${many}`;
}
